import * as angular from 'angular';

import { DigitalSet } from '../../models';
import { IDispatcherService, IDispatcher } from '../';
import { IDigitalSetActionsService } from './digitalSets.actionCreator';

export interface IDigitalSetStoreService {
    getOne: (guid: string) => angular.IPromise<DigitalSet>;
    getAll: (force?: boolean) => angular.IPromise<DigitalSet[]>;
    updateOne: (target: DigitalSet) => angular.IPromise<DigitalSet[]>;
    deleteOne: (guid: string) => angular.IPromise<DigitalSet[]>;
}

export interface IDigitalSetActionDispatcherService extends IDispatcherService<IDigitalSetStoreService> { }

export class DigitalSetActionDispatcherService implements IDigitalSetActionDispatcherService {
    static serviceId = 'digitalSetActionDispatcherService';

    static $inject = ['digitalSetActionsService'];

    constructor(private _actionService: IDigitalSetActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IDigitalSetStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                updateOne: (target: DigitalSet) => dispatch(actionService.updateOne(target)),
                deleteOne: (guid: string) => dispatch(actionService.deleteOne(guid))
            }
        };
    }
}